export default __webpack_public_path__ + "static/media/btn-popup-close.3c625358.svg";